/**
 * Arrows for the generic card scroller `.yours-scroller`
 * (markup: inc/Helpers/Scroller.php, styles: scss/components/_scroller.scss).
 *
 * Scrolling itself is CSS scroll-snap and works without this script. The
 * script shows the arrows, moves the track by one card per click and disables
 * an arrow at the start or end. With nothing to scroll (e.g. the grid from
 * 1024px) the arrows stay hidden.
 */
const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

function initScroller(root) {
    const track = root.querySelector(".yours-scroller__track");
    const nav = root.querySelector(".yours-scroller__nav");

    if (!track || !nav) {
        return;
    }

    const prev = nav.querySelector('[data-scroller-dir="-1"]');
    const next = nav.querySelector('[data-scroller-dir="1"]');

    const step = () => {
        const card = track.firstElementChild;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;

        return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
    };

    const update = () => {
        const max = track.scrollWidth - track.clientWidth;

        prev.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= max - 1;
        nav.hidden = max <= 1;
    };

    [prev, next].forEach((button) => {
        button.addEventListener("click", () => {
            track.scrollBy({
                left: step() * Number(button.dataset.scrollerDir),
                behavior: reducedMotion.matches ? "auto" : "smooth",
            });
        });
    });

    track.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
}

export default function scroller() {
    document.querySelectorAll(".yours-scroller").forEach(initScroller);
}
